<dx-popup [showTitle]="true" title="Nuovo movimento magazzino" [dragEnabled]="false" selectionMode="none"
  [hideOnOutsideClick]="false" [showCloseButton]="true" container=".dx-viewport" visible="true"
  (onHiding)="onEsciClick()" height="80vh">
  <div class="row">
    <div class="col-lg-4 col-md-6 col-sm-8 col-12 offset-lg-8 offset-md-6 offset-sm-4">
      <dx-button stylingMode="contained" text="CONFERMA" icon="save" type="success" (onClick)="onSalvaClick($event)"
        style="width: 150px; margin-right: 10px;">
      </dx-button>
      <dx-button stylingMode="contained" text="ESCI" icon="close" type="danger" (onClick)="onEsciClick()"
        style="width: 100px;">
      </dx-button>
    </div>
  </div>

  <div class="row">
    <div [ngClass]="{'col-12 col-md-6 col-lg-4': gestisciMatricola, 'col-12 col-lg-8':!gestisciMatricola}">
      <form>
        <div class="dx-field">
          <div class="dx-field-label"><b>Data</b></div>
          <div class="dx-field-value">
            <dx-date-box displayFormat=" dd/MM/yyyy" [(value)]="dataMovimento">
              <!-- [height]="26"> -->
              <dx-validator>
                <dxi-validation-rule type="required" message="Inserire la data del movimento">
                </dxi-validation-rule>
              </dx-validator>
            </dx-date-box>
          </div>
        </div>
        <div class="dx-field">
          <div class="dx-field-label"><b>Causale</b></div>
          <div class="dx-field-value">
            <dx-lookup valueExpr="id" [dataSource]="listCausali" [searchEnabled]="true"
              [(value)]="nuovoMovimentoMag.idCausale" displayExpr="descrizione"
              (onValueChanged)="onValueCausaleChanged()">
              <dx-validator>
                <dxi-validation-rule type="required" message="Selezionare causale">
                </dxi-validation-rule>
              </dx-validator>
            </dx-lookup>
          </div>
        </div>
        <div class="dx-field">
          <div class="dx-field-label"><b>Articolo</b></div>
          <div class="dx-field-value">
            <dx-lookup valueExpr="id" [dataSource]="listArticoli" [searchEnabled]="true"
              [(value)]="nuovoMovimentoMag.idArticolo" [displayExpr]="getArticoloDisplayExpr"
              (onValueChanged)="onValueArticoloChanged()">
              <dx-validator>
                <dxi-validation-rule type="required" message="Selezionare articolo">
                </dxi-validation-rule>
              </dx-validator>
            </dx-lookup>
          </div>
        </div>
        <div class="dx-field">
          <div class="dx-field-label"><b>Qta</b></div>
          <div class="dx-field-value">
            <dx-number-box [(value)]="nuovoMovimentoMag.qta" (onValueChanged)="onValueQtaChanged()">
              <dx-validator>
                <dxi-validation-rule type="required" message="Inserire quantità valida">
                </dxi-validation-rule>
              </dx-validator>
            </dx-number-box>
          </div>
        </div>
        <div class="dx-field">
          <div class="dx-field-label"><b>Note</b></div>
          <div class="dx-field-value">
            <dx-text-area [height]="90" [(value)]="nuovoMovimentoMag.note">
            </dx-text-area>
          </div>
        </div>
      </form>
    </div>
    @if (gestisciMatricola && nuovoMovimentoMag.idCausale == causaleInserimento.id) {
    <div class="col-12 col-md-6 col-lg-8">
      <dx-data-grid #dataGridArticoliMatricola [dataSource]="listArticoliMatricola" [showBorders]="true"
        [showRowLines]="true" [showColumnLines]="true" [columnAutoWidth]="true">
        <dxo-paging [pageSize]="10"></dxo-paging>
        <dxo-pager [showPageSizeSelector]="true" [showInfo]="true"></dxo-pager>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-editing mode="batch" [allowAdding]="false" [allowUpdating]="true" [allowDeleting]="false"
          [useIcons]="true">
          <dxo-texts confirmDeleteMessage="Sei sicuro di voler eliminare il dettaglio?"></dxo-texts>
        </dxo-editing>
        <dxi-column dataField="index" caption="">
        </dxi-column>
        <dxi-column dataField="matricola" caption="Matricola">
        </dxi-column>
        <!--<dxi-column *ngFor="let prop of listPropsArtMatricola"
          [dataField]="prop.nome"
          [caption]="prop.nome"
          [dataType]="getDataType(prop.tipo)"
          [format]="getDataFormat(prop.tipo)">
          <dxo-lookup *ngIf="prop.tipo == TIPO_PROPRIETA_ARTICOLO_SELMULTI"
            [dataSource]="prop.selMultiplaDati">
          </dxo-lookup>
        </dxi-column>-->
        @for (prop of listPropsArtMatricola; track prop) {
        <dxi-column dataField="props.{{prop.nome}}" caption="{{prop.nome}}" [dataType]="getDataType(prop.tipo)"
          [format]="getDataFormat(prop.tipo)">
          @if (prop.tipo == TIPO_PROPRIETA_ARTICOLO_SELMULTI) {
          <dxo-lookup [dataSource]="prop.selMultiplaDati">
          </dxo-lookup>
          }
        </dxi-column>
        }
      </dx-data-grid>
    </div>
    }

    @if (gestisciMatricola && nuovoMovimentoMag.idCausale != causaleInserimento.id) {
    <div class="col-12 col-md-6 col-lg-8">
      <dx-data-grid #dataGridArticoliMatricola [dataSource]="listArticoliMatricola" [showBorders]="true"
        [showRowLines]="true" [showColumnLines]="true" [columnAutoWidth]="true">
        <dxo-paging [pageSize]="10"></dxo-paging>
        <dxo-pager [showPageSizeSelector]="true" [showInfo]="true"></dxo-pager>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-editing mode="batch" [allowAdding]="false" [allowUpdating]="true" [allowDeleting]="false"
          [useIcons]="true">
          <dxo-texts confirmDeleteMessage="Sei sicuro di voler eliminare il dettaglio?"></dxo-texts>
        </dxo-editing>
        <dxi-column dataField="index" caption="">
        </dxi-column>
        <dxi-column dataField="id" caption="Articolo Matricola">
          <dxo-lookup [dataSource]="listMatricoleDisponibili" valueExpr="id" displayExpr="matricola">
          </dxo-lookup>
        </dxi-column>
      </dx-data-grid>
    </div>
    }
  </div>

</dx-popup>

<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [(visible)]="loadPanelVisible" [showIndicator]="true"
  [showPane]="true" [shading]="true" [hideOnOutsideClick]="false">
</dx-load-panel>